import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const profileManagementRoutes = [
  {
    path: 'profile-management',
    component: SuperAdminDummyRouter,
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/profileManagement/list/ProfileListView.vue'),
      },
      {
        path: ':profileId',
        component: () =>
          import('@/features/settingsManagement/profileManagement/edit/ProfileEditView.vue'),
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/profileManagement/edit/ProfileEditView.vue'),
      },
    ],
  },
]
